module.exports = __webpack_public_path__ + "static/media/icn-filter.ab20ea68.svg";